import { useEffect, useState } from 'react';
import { getThresholdList, updateThreshold } from '../../services/thresholdService';

export default function ThresholdModal({ onClose }) {
  const [thresholds, setThresholds] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await getThresholdList();
      if (res.success) setThresholds(res.relation);
    };
    fetchData();
  }, []);

  const handleUpdate = async (id, newMinute) => {
  const result = await updateThreshold(id, newMinute);

  if (result.success === false) {
    alert(result.message || '수정 실패');
    return;
  }

  alert(result.message || '수정 완료');

  const updated = thresholds.map((item) =>
    item.id === id ? { ...item, minute_threshold: newMinute } : item
  );
  setThresholds(updated);
};

  return (
    <div className="modalbg">
      <div className="thres_modal">
        <h3>알림 기준 시간 설정</h3>
        <div className='table'>
            <table>
            <thead>
                <tr>
                <th>설명</th>
                <th>알림시간(분)</th>
                <th>수정</th>
                </tr>
            </thead>
            <tbody>
                {thresholds.map((t) => (
                <tr key={t.id}>
                    <td>{t.description}</td>
                    <td>
                    <input
                        type="number"
                        value={t.minute_threshold}
                        onChange={(e) =>
                        setThresholds((prev) =>
                            prev.map((item) =>
                            item.id === t.id
                                ? { ...item, minute_threshold: e.target.value }
                                : item
                            )
                        )
                        }
                    />
                    </td>
                    <td>
                    <button onClick={() => handleUpdate(t.id, t.minute_threshold)}>저장</button>
                    </td>
                </tr>
                ))}
            </tbody>
            </table>
        </div>
        <button onClick={onClose} className='cancelbtn'>닫기</button>
      </div>
    </div>
  );
}
